import { Button, Card, Col, Form, Input, Modal, Row, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Client from "redux/models/client";
import { selectConfigration } from "redux/slices/configrationSlice";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import { isPermissionPresent } from "utilities/generalUtility";
import UDF from "redux/models/udf";
import { setJobSourceUdf } from "redux/slices/udfSlice";
import ClassTable from "features/clients/details/classes/classTable";
import { convertIntoDashUSFormat } from "utilities/dateUtility";
import styles from "../jobList.module.scss";
import CreateClass from "../createClass";
import { usePageFilter } from "../../../../../hooks/usePageFilters";
import { DataTableLayout } from "../../../../../common/components/dataTableLayout/dataTableLayout";

export const ClientClassesContainer = () => {
  const gridRef = useRef(null);
  const { id } = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [clientClass, setClientClass] = useState(null);

  const [modalState, setModalState] = useState({
    isCreateClassModalVisible: false,
    isLoadingClassModal: false,
    isLoadingUploadModal: false,
    uploadCSVErrors: null,
  });

  const lookupTables = useSelector(selectConfigration).lookup;

  const [search, setSearch] = usePageFilter(`client_${id}_class_search`);

  const getClientClassList = async () => {
    try {
      const res = await Client.getClientClassList(id);

      const tableData = res.map((el) => {
        return {
          id: el.id,
          title: el.title,
          classSize: el.classVacancies[0]?.currentOpenings ?? 0,
          classDateReceived: convertIntoDashUSFormat(el.dateClassReceived),
          classStartDate: convertIntoDashUSFormat(el.classStartDate),
          offerApprovalDate: el.offerApprovalDate,
          internalManagerId: el.internalManagerId,
          regionalDirectorId: el.regionalDirectorId,
          humanResourceId: el.humanResourceId,
          humanResource: el.humanResource,
          regionalDirector: el.regionalDirector,
          internalManager: el.internalManager,
          notes: el.notes,
          classStatusId: el.classStatusId,
          classStatus: el.classStatus?.name,
        };
      });

      setClientClass(tableData);
    } catch (error) {
      console.error(error);
    }
  };

  const getJobUdfs = async (entityKeyId = null) => {
    const jobUdfs = await UDF.getEditUdfFields({
      clientId: id,
      entityId: K.UDF.Entities.JobSource.id,
      entityKey: K.UDF.Entities.JobSource.key,
      entityKeyId,
      isVisible: 1,
    });

    dispatch(setJobSourceUdf(jobUdfs));
  };

  const showModal = () => {
    setModalState((prev) => {
      return { ...prev, isCreateClassModalVisible: true };
    });
  };

  const handleCancel = () => {
    form.resetFields();
    setModalState((prev) => {
      return { ...prev, isCreateClassModalVisible: false };
    });
  };

  const rowClickedHandler = (event) => {
    history.push(`/clients/${id}/class/${event.data.id}`);
  };

  useEffect(() => {
    getClientClassList();
  }, []);

  const afterModalClose = () => {
    form.resetFields();
  };

  return (
    <>
      <DataTableLayout
        searchDefaultValue={search}
        onSearchChange={setSearch}
        actions={[
          {
            permissions: [K.Permissions.CreateClass],
            renderer: () => (
              <Col>
                <Button type="primary" onClick={showModal}>
                  Create Class
                </Button>
              </Col>
            ),
          },
        ]}
      >
        <ClassTable
          rowData={clientClass}
          setClientClass={setClientClass}
          gridRef={gridRef}
          onRowClicked={rowClickedHandler}
          getClientClassList={getClientClassList}
          search={search}
        />
      </DataTableLayout>

      <Modal
        centered
        width={632}
        open={modalState.isCreateClassModalVisible}
        okText="Submit"
        onOk={form.submit}
        okButtonProps={{ loading: modalState.isLoadingClassModal }}
        onCancel={handleCancel}
        closeIcon={<i className="icon-closeable" />}
        className="s2-theme-style jobsList modal-overflow-auto"
        title="Create Class"
        afterClose={afterModalClose}
      >
        <CreateClass
          form={form}
          clientId={id}
          lookupTables={lookupTables}
          setClientJobs={setClientClass}
          setModalState={setModalState}
          getClientClassList={getClientClassList}
          getJobUdfs={getJobUdfs}
        />
      </Modal>
    </>
  );
};
